import { clientConstants } from '../_constants/client.constants'

const INITIAL_STATE = {
  allClients: [],
}

const clientReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case clientConstants.GET_ALL_CLIENTS:
      return Object.assign({}, state, {
        allClients: action.payload.clients,
      })
    default:
      return state
  }
}

export default clientReducer
